/*
 * DLUX routine tabs
 * Progressive enhancement: the markup ships every panel visible, so a visitor
 * with no JavaScript still sees all the products. This hides the inactive
 * panels and wires up the ARIA tabs pattern with roving tabindex.
 */
(function () {
  function init(root) {
    if (root.getAttribute('data-dlux-routine-tabs-ready') === 'true') return;
    root.setAttribute('data-dlux-routine-tabs-ready', 'true');

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-dlux-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-dlux-panel]'));

    if (tabs.length < 2 || tabs.length !== panels.length) return;

    var active = 0;

    function select(i, moveFocus) {
      active = ((i % tabs.length) + tabs.length) % tabs.length;

      tabs.forEach(function (tab, n) {
        var on = n === active;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
        tab.classList.toggle('is-active', on);
      });

      panels.forEach(function (panel, n) {
        panel.hidden = n !== active;
      });

      if (moveFocus) tabs[active].focus();
    }

    tabs.forEach(function (tab, n) {
      tab.addEventListener('click', function () {
        select(n, false);
      });

      tab.addEventListener('keydown', function (e) {
        var key = e.key;
        if (key === 'ArrowRight' || key === 'ArrowDown') {
          e.preventDefault();
          select(active + 1, true);
        } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
          e.preventDefault();
          select(active - 1, true);
        } else if (key === 'Home') {
          e.preventDefault();
          select(0, true);
        } else if (key === 'End') {
          e.preventDefault();
          select(tabs.length - 1, true);
        }
      });
    });

    // Collapse to the first panel now that the script is running.
    select(0, false);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-dlux-routine-tabs]').forEach(init);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
